import { FC, MouseEvent, useState } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { COLORS } from 'services/constants/colors';
import { TTabGroupMenuProps } from './types';

/** Dropdown that collapses several tabs into one tab-bar entry, mirroring the header nav groups. */
export const TabGroupMenu: FC<TTabGroupMenuProps> = ({
	name,
	items,
	selectedValue,
	onItemClick,
}) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const isGroupActive = items.some((item) => item.value === selectedValue);

	const handleOpen = (event: MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleItemClick = (value: string) => {
		setAnchorEl(null);
		onItemClick(value);
	};

	return (
		<>
			<Button
				onClick={handleOpen}
				endIcon={<KeyboardArrowDownIcon sx={{ ml: -0.5 }} />}
				sx={{
					color: COLORS.PRIMARY,
					opacity: isGroupActive ? 0.5 : 1,
					fontWeight: 'bold',
					fontSize: '0.875rem',
					lineHeight: 1.25,
					minHeight: '20px',
					minWidth: 'auto',
					p: '0 10px',
					whiteSpace: 'nowrap',
				}}
			>
				{name}
			</Button>
			<Menu
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={handleClose}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
				transformOrigin={{ vertical: 'top', horizontal: 'left' }}
			>
				{items.map((item) => (
					<MenuItem
						key={item.value}
						onClick={() => handleItemClick(item.value)}
						sx={{
							'&.MuiMenuItem-root': {
								color: COLORS.PRIMARY,
								opacity: item.value === selectedValue ? 0.5 : 1,
								fontWeight: 'bold',
								fontSize: '0.8rem',
								justifyContent: 'flex-start',
								lineHeight: '1.2rem',
							},
						}}
					>
						{item.label}
					</MenuItem>
				))}
			</Menu>
		</>
	);
};
